import styled from 'styled-components'

import Icon from '~/components/icon'
import { font } from '~/styles/utils'

export const Text = styled.span`
  ${font('bold')};
`

export const StyledIcon = styled(Icon)`
  margin-right: 5px;
`
